import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import RefinanceDebtSection from './RefinanceDebtSection/Content';

const RefinanceDebtSectionPicker = ({ resource, handleAddRefinanceDebt, handleModifyRefinanceDebt }) => {
  if (!resource?.relationship(fr.relationships.addRefinanceDebt.name)) {
    return null;
  }
  return (
    <RefinanceDebtSection
      resource={resource}
      handleAddRefinanceDebt={handleAddRefinanceDebt}
      handleModifyRefinanceDebt={handleModifyRefinanceDebt}
    />
  );
};

RefinanceDebtSectionPicker.propTypes = {
  resource: PropTypes.object.isRequired,
  handleAddRefinanceDebt: PropTypes.func.isRequired,
  handleModifyRefinanceDebt: PropTypes.func.isRequired,
};

export default RefinanceDebtSectionPicker;
